import { type RemovableRef } from '@vueuse/core';

export interface UseWelcomeModalReturn {
    isWelcomeModalAccepted: RemovableRef<boolean>;
}

export const useWelcomeModal = (
    localStorageItemName = 'isWelcomeModalAccepted'
) => {
    const isWelcomeModalAccepted = useLocalStorage(localStorageItemName, false);

    return {
        isWelcomeModalAccepted,
    };
};
